import React from "react";
import { Switch, Route } from "react-router-dom";
import api from "axios";

import Loader from "react-loader-spinner";

// Components
import GiftPackRegistration from "./pages/validation/giftPackRegistration";
import GiftPackActivate from "./pages/activate/giftPackActivate";
import GiftPackCompleted from "./pages/completed/giftPackCompleted";
import NotFound from "./pages/not-found/notFound";

// Styles
import "./app.scss";

class App extends React.Component {
  state = {
    isLoading: true,
    config: null,
    activationNumber: null,
    barcode: null,
    giftPack: null
  };

  constructor() {
    super();

    // Load APIRequest Urls
    api
      .get("/config/config.json")
      .then(response => {
        this.setState({ config: response.data });
      })
      .then(() => {
        this.setState({ isLoading: false });
      });
  }

  updateState = stateData => {
    this.setState(stateData);
  };

  pageContentRender = () => {
    if (this.state.isLoading) {
      return (
        <div className="row justify-content-center">
          <Loader type="Oval" color="#003087" height="100" width="100" />
        </div>
      );
    }

    return (
      <Switch>
        <Route exact path="/" render={props => <GiftPackRegistration {...props} config={this.state.config} updateAppState={this.updateState} />} />
        <Route
          path="/activate"
          render={props => (
            <GiftPackActivate
              {...props}
              config={this.state.config}
              activationNumber={this.state.activationNumber}
              barcode={this.state.barcode}
              updateAppState={this.updateState}
            />
          )}
        />
        <Route
          path="/completed"
          render={props => (
            <GiftPackCompleted
              {...props}
              config={this.state.config}
              activationNumber={this.state.activationNumber}
              barcode={this.state.barcode}
              giftPack={this.state.giftPack}
            />
          )}
        />
        <Route component={NotFound} />
      </Switch>
    );
  };

  render() {
    return (
      <div id="wrapper">
        <header className="header">
          <div className="header-content">
            <div className="header-wrap content-width">
              <h1 className="header-logo">
                <a className="header-logo-link">
                  <img src="assets/images/logo.png" alt="WHSmith Logo" />
                </a>
              </h1>
            </div>
          </div>
        </header>

        <div>
          <div id="main" role="main" className="content-width content-holder-padding">
            <div className="column-wrapper">
              <div className="primary-content">{this.pageContentRender()}</div>
            </div>
          </div>
        </div>

        <footer className="footer-main">
          <div className="content-width text-center">
            <p>
              WHS and the supplier of your gift subscription will respect the security of your personal data and to treat it in accordance with the
              law.
              <br />
              We do not allow our third-party service providers to use your personal data for their own purposes and only permit them to process your
              personal data for specific purpose of fulfilling your gift subscription.
            </p>
          </div>
          <div className="footer-logo">
            <div className="content-width">
              <div className="content-asset">
                <img src="assets/images/logo_footer.png" alt="WHSmith 225 Logo" />
              </div>
            </div>
          </div>
          <div className="footer-copy">
            <div className="content-width">
              <div className="content-asset d-flex">
                <div className="flex-grow-1">
                  <span className="copy-bold">&copy; Copyright 1999-2018</span> WHSmith and its suppliers. All rights reserved.
                </div>
                <div className="footer-links">
                  <a
                    href="https://www.whsmith.co.uk/fcp/content/Help-OnlinePolicies-TermsAndConditions/content"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Terms
                  </a>{" "}
                  |{" "}
                  <a
                    href="https://www.whsmith.co.uk/fcp/content/Help-OnlinePolicies-PrivacyPolicyandCookies/content"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Privacy Policy
                  </a>{" "}
                  |{" "}
                  <a
                    href="https://www.whsmith.co.uk/fcp/content/Help-GiftPackandGiftCard-RegisterYourGiftPack/content"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    FAQ
                  </a>{" "}
                  |{" "}
                  <a href="https://www.whsmith.co.uk/fcp/content/contact-us/content" target="_blank" rel="noopener noreferrer">
                    Contact Us
                  </a>
                </div>
              </div>
            </div>
          </div>
        </footer>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js